<template>
    <div>
        <div v-for="(item, index) in params || []" :key="index">
            <el-row :gutter="20" type="flex" align="top">
                <el-col
                    :span="4"
                    :offset="ii == 0 ? 1 : 0"
                    v-for="(ic, ii) in item.material"
                    :key="ii"
                >
                    <CardItem :material="ic" />
                </el-col>
                <el-col :span="12"
                    ><div class="grid-content" style="padding-top: 34px">
                        <span
                            style="
                                display: inline-block;
                                width: 100%;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                white-space: nowrap;
                            "
                        >
                            创意规格：{{ item.flow_scene_text }} -
                            {{ item.global_spec_id_text }}
                        </span>
                    </div></el-col
                >
            </el-row>
            <el-divider></el-divider>
        </div>
    </div>
</template>

<script>
import CardItem from "./cardItem"
export default {
    name: "expandItem",
    components: {
        CardItem,
    },
    props: ['params'],
    data() {
        return {}
    },
    // computed: {
    //     params() {
    //         console.log(this.params)
    //     }
    // },
    mounted() {
    },
    methods: {},
}
</script>

<style scoped></style>
